import { GetInTouchConst } from "../Constants/GetInTouchConstants";

const initialState = {
  loader: false,
  queries: [],
  queriesError: null,
  actionSuccess: null,
  actionError: null,
};

const getInTouchReducer = (state = initialState, action) => {
  switch (action.type) {
    case GetInTouchConst.FETCH_ALL_REQUEST:
      return { ...state, loader: true, queriesError: null };
    case GetInTouchConst.FETCH_ALL_SUCCESS:
      return { ...state, loader: false, queries: action.result.data ?? [] };
    case GetInTouchConst.FETCH_ALL_FAIL:
      return { ...state, loader: false, queriesError: action.result };

    case GetInTouchConst.CLEAR_ACTION:
      return { ...state, actionSuccess: null, actionError: null };

    default:
      return state;
  }
};

export default getInTouchReducer;
